import {useEffect, useState} from 'react';

import {decompressDescription, useDbData} from '@website_frontend/lib/db_cache';

export const DUMMY_ID = 11123456;

export const DUMMY_DESCRIPTION =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';

const descriptionCache = new Map([[DUMMY_ID, DUMMY_DESCRIPTION]]);

//

export function getDescription(id: number): string | undefined {
  return descriptionCache.get(id);
}

export function setDescription(id: number, description: string): void {
  descriptionCache.set(id, description);
}

export function useDescription(id: number): string | undefined {
  const {data} = useDbData();
  const [unzipped, setUnzipped] = useState<string | undefined>(getDescription(id));
  useEffect(() => {
    if (data !== undefined && unzipped === undefined) {
      decompressDescription(data?.get(id)?.description ?? new Uint8Array()).then(description => {
        setUnzipped(description);
      });
    }
  }, [data, id, unzipped]);
  return unzipped;
}
